(function($){

    /**
     * Scroll behaviour
     */
    VIV.behaviours.scrolled = {

        /**
         * Attach behaviour
         *
         * @param context
         */
        attach : function (context) {
            if ($(context).find('body').length && !$(context).find('.docs').length) {
                this.initOnScroll();
            }
        },

        /**
         * Add/Remove scrolled class on scroll
         */
        initOnScroll : function () {
            $(window).scroll(function () {
                var scrollTop = $(this).scrollTop();
                if (scrollTop > 10) {
                    document.documentElement.classList.add('scrolled');
                } else{
                    document.documentElement.classList.remove('scrolled');
                }
            });
            $(window).trigger('scroll');
        }
    };

})(jQuery);
